import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SystemSiteService } from 'app/services/system-site.service';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-info-popi',
  templateUrl: './info-popi.component.html',
  styleUrls: ['./info-popi.component.scss']
})
export class InfoPopiComponent {

  Data: any = [];

  downloadSubscription: Subscription = null;
  downloadFileSubscription: Subscription = null;
  download_url: string = `${environment.site_URL}`;
  public result_message = ""
  constructor(private systemSiteService: SystemSiteService, private router: Router) { }



  ngOnInit() {


    this.LoadData();




  }


  LoadData() {
    this.downloadSubscription = this.systemSiteService.get_downloads("popi").subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.Data = data.result_data;

      },
      error: (error) => { console.log(error) },
    })
  }




  downloadFile(id: string, filename: string): void {
    this.systemSiteService.get_download_file(id).subscribe(data => {
      const blob = new Blob([data], { type: data.type });  // Adjust the MIME type as needed
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}`);  // Adjust the file extension/name as needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  }

  ngOnDestroy(): void {
    if (this.downloadSubscription)
      this.downloadSubscription.unsubscribe();
      if (this.downloadFileSubscription)
      this.downloadFileSubscription.unsubscribe();
  }



}
